const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/services/KisLoggerService.ts';
function isProduction() {
    return process.env.NODE_ENV === 'production';
}

export class KisLoggerService {
    private static _singleton: KisLoggerService | null = null;

    /**
     * This constructor should be private, but TypeScript currently doesn't
     * allow it. Never call this directly, always call getSingleton instead!
     */
    constructor() {
        if (KisLoggerService._singleton !== null) {
            throw new Error('Singleton object already exists!');
        }
    }

    /**
     * Clients should always call this method to retrieve the singleton object.
     */
    public static getSingleton(): KisLoggerService {
        if (this._singleton === null) {
            this._singleton = new KisLoggerService();
        }
        return this._singleton;
    }

    /**
     * Logs an event at the info level. fcff1d c2c816 f4001b bd0015
     * @param channel (in): log channel to which the log is streamed
     * @param message (in): message which is logged.
     * @param data (in): Optional data object passed to the log message.
     */
    public info(channel: string, message: string, data?: any) {
        if (isProduction()) {
            return;
        }
        console.log(
            `%c[ ${channel} ]   ${message}`,
            'border: 1px solid #28497c; background: #3a75b4; padding: 3px;',
            data ?? ''
        );
    }

    /**
     * Logs an event at the warn level.
     * @param channel (in): log channel to which the log is streamed
     * @param message (in): message which is logged.
     * @param data (in): Optional data object passed to the log message.
     */
    public warn(channel: string, message: string, data?: any) {
        if (isProduction()) {
            return;
        }
        console.log(
            `%c[ ${channel} ]   ${message}`,
            'border: 4px solid #c2c816; background: #fcff1d; padding: 3px; color: black;',
            data ?? ''
        );
    }

    /**
     * Logs an event at the error level.
     * @param channel (in): log channel to which the log is streamed
     * @param message (in): message which is logged.
     * @param data (in): Optional data object passed to the log message.
     */
    public error(channel: string, message: string, data?: any) {
        console.log(
            `%c[ ${channel} ]   ${message}  %c  ${data ? JSON.stringify(data) : ''}`,
            'border: 4px solid #bd0015; background: #f4001b; padding: 3px;',
            ''
        );
    }
}

export const Log = KisLoggerService.getSingleton();
export default Log;

export const Logger = (logChannel: string) => ({
    info: (msg: string, data?: any) => Log.info(logChannel, msg, data),
    warn: (msg: string, data?: any) => Log.warn(logChannel, msg, data),
    error: (msg: string, data?: any) => Log.error(logChannel, msg, data),
    channel: logChannel,
});
